import type {
	InviteUserResponse,
	InvitedUser,
	InvitedUserResult,
} from '@atlassian/invite-people/types';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { PACKAGE_NAME } from '@atlassian/jira-growth-utils/src/common/constants.tsx';
import { getAriConfig, toAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { SOFTWARE } from '@atlassian/jira-shared-types/src/application-key.tsx';

export const getInvitedJswUsers = (
	inviteUsersResponse: InviteUserResponse,
): (InvitedUser & InvitedUserResult)[] => {
	try {
		if (
			inviteUsersResponse.status === 'fulfilled' &&
			inviteUsersResponse.value.responseStatus === 'success' &&
			'invited' in inviteUsersResponse.value.response
		) {
			const invitedUsers = inviteUsersResponse.value.response.invited;
			return invitedUsers.filter((invitedUser) => {
				const productInvites = Object.keys(invitedUser.results);
				return productInvites.some((invite) => {
					const ari = toAri(invite);
					return ari
						? getAriConfig(ari).resourceOwner === SOFTWARE &&
								invitedUser.results[invite] === 'INVITED'
						: false;
				});
			});
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		fireErrorAnalytics({
			error: e,
			meta: {
				id: 'getInvitedJswUsers',
				packageName: PACKAGE_NAME,

				teamName: 'growth-tako',
			},
		});
	}
	return [];
};
